import {AbstractParameter} from "./AbstractParameter";
import textHtml from './text.html?raw';

export let template = textHtml;

export class viewModel extends AbstractParameter {

    protected getParams() {
        return {
            canOpenInDialog: true,
            expression: this.parameter.val,
            objectTypeId: this.parameter.objectTypeId,
            objectTypeIds: this.parameter.objectTypeIds,
            placeholder: this.getPlaceholder(),
            dynamicSupport: false,
        }
    }

}
